module.exports = __webpack_public_path__ + "font/element-icons.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 231
// module chunks = 0